import DataTableHeader from 'modules/Users/DataTableHeader';

import { useAppSelector } from 'hooks/redux';
import { UserTableModel, userTableColumns } from 'modules/Users/DataTableDef';
import DataTableFooter from 'modules/Users/DataTableFooter';
import DataTableRow from 'modules/Users/DataTableRow';
import './usersDatatable.css';

type Props = {
  users: UserTableModel[];
};

const UsersDataTable = ({ users }: Props) => {
  const pageSize = useAppSelector(state => state.usersTable.pageSize);
  const pageIndex = useAppSelector(state => state.usersTable.pageIndex);

  const rows = users.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);

  return (
    <>
      <table className="users-datatable">
        <DataTableHeader users={users} />
        <tbody>
          {users.length === 0 ? (
            <tr>
              <td className="empty" colSpan={userTableColumns.length}>
                No result
              </td>
            </tr>
          ) : (
            <>
              {rows.map(user => (
                <DataTableRow user={user} key={user.id} />
              ))}
            </>
          )}
        </tbody>
      </table>
      <DataTableFooter users={users} />
    </>
  );
};

export default UsersDataTable;
